import { Dispatcher2txct93ff9b99 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/DeletePinCommand.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher_0 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { Dispatcher2k7js8ct0qtp5 as Dispatcher_1 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/DeletePairAssignmentsCommand.mjs';
import { Dispatcher3kdydho2ojhnk as Dispatcher_2 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SaveSlackIntegrationCommand.mjs';
import { Dispatcher27uwezb7p8fpg as Dispatcher_3 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantDiscordAccessCommand.mjs';
import { Dispatcherb76d0p5pxiow as Dispatcher_4 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pin/SavePinCommand.mjs';
import { Dispatchervu4hb3oerxrm as Dispatcher_5 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/GrantSlackAccessCommand.mjs';
import { Dispatchernurlbopdkn3a as Dispatcher_6 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/SpinCommand.mjs';
import { Dispatcher39hthxqv8voqz as Dispatcher_7 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/SavePlayerCommand.mjs';
import { Dispatcher1dgi8c7arrsv1 as Dispatcher_8 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/DeletePlayerCommand.mjs';
import { Dispatcher2jh9je6zwmtr7 as Dispatcher_9 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/DeletePartyCommand.mjs';
import { Dispatchernmy2not8m2c7 as Dispatcher_10 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/pairassignmentdocument/SavePairAssignmentsCommand.mjs';
import { Dispatcher3f3rv68jjbf7x as Dispatcher_11 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/CreateSecretCommand.mjs';
import { Dispatcher3ngwv5mtnm33a as Dispatcher_12 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/ApplyBoostCommand.mjs';
import { Dispatcher3r3trxa1ofgr6 as Dispatcher_13 } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/secret/DeleteSecretCommand.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientDispatcherClass;
function ClientDispatcher() {
  if (ClientDispatcherClass === VOID) {
    class $ {
      constructor(sdkDispatcher) {
        this.d7j_1 = sdkDispatcher;
      }
      *q2g(command, $completion) {
        return yield* this.d7j_1.q2g(command, $completion);
      }
      *m2i(command, $completion) {
        return yield* this.d7j_1.m2i(command, $completion);
      }
      *i2h(command, $completion) {
        return yield* this.d7j_1.i2h(command, $completion);
      }
      *r2h(command, $completion) {
        return yield* this.d7j_1.r2h(command, $completion);
      }
      *a2i(command, $completion) {
        return yield* this.d7j_1.a2i(command, $completion);
      }
      *g2i(command, $completion) {
        return yield* this.d7j_1.g2i(command, $completion);
      }
      *p2i(command, $completion) {
        return yield* this.d7j_1.p2i(command, $completion);
      }
      *t2g(command, $completion) {
        return yield* this.d7j_1.t2g(command, $completion);
      }
      *w2g(command, $completion) {
        return yield* this.d7j_1.w2g(command, $completion);
      }
      *o6t(query, $completion) {
        return yield* this.d7j_1.o6t(query, $completion);
      }
      *o2h(command, $completion) {
        return yield* this.d7j_1.o2h(command, $completion);
      }
      *u2h(command, $completion) {
        return yield* this.d7j_1.u2h(command, $completion);
      }
      *d2i(command, $completion) {
        return yield* this.d7j_1.d2i(command, $completion);
      }
      *j2i(command, $completion) {
        return yield* this.d7j_1.j2i(command, $completion);
      }
      *x2h(command, $completion) {
        return yield* this.d7j_1.x2h(command, $completion);
      }
      *z2g(command, $completion) {
        return yield* this.d7j_1.z2g(command, $completion);
      }
    }
    initMetadataForClass($, 'ClientDispatcher', VOID, VOID, [Dispatcher(), Dispatcher_0(), Dispatcher_1(), Dispatcher_2(), Dispatcher_3(), Dispatcher_4(), Dispatcher_5(), Dispatcher_6(), Dispatcher_7(), Dispatcher_8(), Dispatcher_9(), Dispatcher_10(), Dispatcher_11(), Dispatcher_12(), Dispatcher_13()], [1]);
    ClientDispatcherClass = $;
  }
  return ClientDispatcherClass;
}
//region block: exports
export {
  ClientDispatcher as ClientDispatcher1p2vginamq4dq,
};
//endregion

//# sourceMappingURL=ClientDispatcher.mjs.map
